import { Handle, Position } from "@xyflow/react";
import { memo } from "react";
import "./CustomNode.css"; // Importando o CSS externo
import { FaHelmetSafety } from "react-icons/fa6";
const CustomNode = ({ data }: any) => {
  const HelmetIcon = FaHelmetSafety as unknown as React.FC;

  return (
    <div
      className={`border rounded-lg px-6 py-2 border-black relative transition-all duration-500 ease-in-out ${
        data.falha || data?.falhaAtraso ? "pulsating-border" : ""
      }`}
    >
      {/* Indicador de falha */}
      {data.falha && <div className="falha-indicador">⚠️</div>}
      {data.falhaAtraso && <div className="falha-indicador">⏳</div>}
      {!data?.leitura ? (
        <div className="nao-comissionado">
          <HelmetIcon />
        </div>
      ) : null}
      {data.label}

      {/* Handles para conexão */}
      <Handle type="source" position={Position.Left} isConnectable id="left" />
      <Handle type="target" position={Position.Left} isConnectable id="left" />

      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable
        id="bottom"
      />
      <Handle
        type="target"
        position={Position.Bottom}
        isConnectable
        id="bottom"
      />

      <Handle type="source" position={Position.Top} isConnectable id="top" />
      <Handle type="target" position={Position.Top} isConnectable id="top" />

      <Handle
        type="source"
        position={Position.Right}
        isConnectable
        id="right"
      />
      <Handle
        type="target"
        position={Position.Right}
        isConnectable
        id="right"
      />
    </div>
  );
};

export default memo(CustomNode);
